"use client";

import { Input } from "@watt/ui/components/ui/input";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import type React from "react";
import { useVerification } from "./verification-context";

export interface VerificationInputProps
  extends Omit<
    React.ComponentPropsWithoutRef<typeof Input>,
    "value" | "onChange" | "ref"
  > {
  onValueChange?: (value: string) => void;
  ref?: React.Ref<HTMLInputElement>;
}

export function VerificationInput({
  className,
  onValueChange,
  disabled,
  ref,
  ...props
}: VerificationInputProps) {
  const { state, config, actions } = useVerification();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    actions.updateValue(value);
    onValueChange?.(value);
    // Clear any existing errors when user types
    if (state.error) {
      actions.clearError();
    }
  };

  return (
    <Input
      className={cn(
        "flex-1",
        !state.value && "text-muted-foreground",
        className
      )}
      disabled={disabled || config.disabled || state.isSending}
      onChange={handleChange}
      ref={ref}
      value={state.value}
      {...props}
    />
  );
}
